function SectionLabel({ eyebrow, title, align = 'left', light = false }) {
  const alignment = align === 'center' ? 'items-center text-center' : 'items-start text-left';
  const eyebrowColor = light ? 'text-hub-peach' : 'text-hub-coral';
  const titleColor = light ? 'text-hub-cream' : 'text-hub-forest';

  return (
    <div className={`flex flex-col gap-3 ${alignment}`}>
      <p className={`text-xs font-black uppercase tracking-[0.28em] ${eyebrowColor}`}>{eyebrow}</p>
      <h2 className={`max-w-3xl font-display text-4xl font-bold leading-tight md:text-5xl ${titleColor}`}>
        {title}
      </h2>
    </div>
  );
}

export default SectionLabel;
